import type React from 'react';

import { PageHeader } from '@vlabs/monokit/shared/ui/page';
import { Breadcrumb, Breadcrumbs } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import { generatePath } from 'react-router-dom';

import { useCreateHandlerTranslation } from './i18n';

function CreateHandlerPageHeader(): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();

  return (
    <PageHeader
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb
            caption={t('breadcrumb.handlers')}
            href={generatePath(routes.handlers.all)}
          />
          <Breadcrumb caption={t('breadcrumb.new')} />
        </Breadcrumbs>
      )}
      title={t('title')}
    />
  );
}

export { CreateHandlerPageHeader };
